// Single seam for every publisher-facing devtools message so the prefix can't
// drift across the ~70 call sites that log one. Only two levels — no
// console.info — because Chrome/Firefox devtools render info identically to
// console.log (no color, no icon), so on a page with other scripts logging
// it's easy to lose. Severity convention:
//  - error: the call is misused (bad/missing args) or fails outright; nothing
//    further happens for that call.
//  - warn: everything else worth a publisher's attention, including a
//    documented no-op they should be able to explain without guessing (e.g.
//    showPaywall self-suppressing for an already-entitled visitor) as well as
//    a degraded-but-continuing state.
const PREFIX = '[ezsubscriptions]';

export function logWarn(message: string, ...details: unknown[]): void {
  console.warn(`${PREFIX} ${message}`, ...details);
}

export function logError(message: string, ...details: unknown[]): void {
  console.error(`${PREFIX} ${message}`, ...details);
}
